import React from "react";
import { Modal } from "components/common";
import { Form, Label, SelectField } from "components/ui";
import { connectReduxReducers } from "hocs";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
const BuyPackageModal = ({ auth, organizations, is_visible, closeModal }) => {
  const [employeeCount, setEmployeeCount] = React.useState(1);

  React.useEffect(() => {
    console.log("Updated employee count:", employeeCount);
  }, [employeeCount]);
  // const initialOptions = {
  //   clientId:
  //     "AaQaJEJuFY84KiASHs2d6VJ5SZVG8YXhFuyHAFh7eCf8fLUU-hNNHevlm3HowEfsA1C0uZpHZMNz5Oje",
  //   currency: "USD",
  //   intent: "subscription",
  //   vault: true,
  // };
  const initialOptionsSandbox = {
    clientId:
      "ATicma2J6xZLK7ZVKTMGCIfFqVRus9JxXYma-ZrUTJ0XUKJmB07Wx4Mr7zbe7KgdAbDV_4H48vlQ-d3k",
    currency: "USD",
    intent: "subscription",
    vault: true,
  };
  // const planId = "P-9BR69560G70637125M4IH4BA";
  const planIdSandbox = "P-1YH5167763220891FM4ICHOQ";
  let numero = 1;

  const handleApprove = (data, actions) => {
    const dataForm = {
      subscription_id: data.subscriptionID,
      employee_count: numero,
      tier: "BASIC",
    };
    console.log("Subscription approved successfully.");
    console.log("Subscription ID:", data.subscriptionID);
    organizations.createPaymentOrganization(
      auth.user?.id,
      dataForm,
      (response) => {
        if (response.status === 201) {
          closeModal(true);
        }
      }
    );
  };

  const handleSubmit = (data) => {
    console.log(data);
  };
  return (
    <Modal
      is_visible={is_visible}
      closeModal={closeModal}
      exitOnOverlayClick
      contentClassName="grid grid-gap-20"
    >
      <h1>Completa tu compra</h1>
      <p>
        Estas comprando el paquete basic, para mas info contactanos al correo{" "}
        <a href="mailto:accounts@panzofi.com">accounts@panzofi.com</a>
      </p>

      <Form onSubmit={handleSubmit} className="pz-form">
        {({ onChange }) => (
          <React.Fragment>
            <PayPalScriptProvider options={initialOptionsSandbox}>
              <SelectField
                label={"Paquete"}
                name="language"
                onChange={onChange}
                options={[
                  { value: "BASIC", label: "Basic" },
                  // { value: "business", label: "Business" },
                  // { value: "enterprice", label: "Enterprice" },
                ]}
                defaultValue={{ value: "BASIC", label: "Basic" }}
                notRequired={false}
              />
              <section className="pz-form__field">
                <Label htmlFor={employeeCount}>Numero de empleados</Label>
                <input
                  className="pz-form__input"
                  type="number"
                  id="employeeCount"
                  value={employeeCount}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    console.log(value);
                    numero = Number(e.target.value);
                    setEmployeeCount(value);
                    console.log(employeeCount);
                  }}
                  required
                />
              </section>

              <br />
              <PayPalButtons
                style={{ layout: "vertical" }}
                createSubscription={(data, actions) => {
                  return actions.subscription
                    .create({
                      plan_id: planIdSandbox,
                      quantity: numero,
                    })
                    .then((subscriptionId) => {
                      console.log(
                        "Subscription created successfully:",
                        subscriptionId
                      );
                      return subscriptionId;
                    })
                    .catch((error) => {
                      console.error("Error creating subscription:", error);
                      throw error;
                    });
                }}
                onApprove={(data, actions) => handleApprove(data, actions)}
                onError={(error) => {
                  console.error("Error in PayPal Buttons:", error);
                }}
              ></PayPalButtons>
            </PayPalScriptProvider>
          </React.Fragment>
        )}
      </Form>
    </Modal>
  );
};

export default connectReduxReducers(BuyPackageModal, "auth", "organizations");
